export default "<p>choferes-tabla works!</p>\n"